import { create } from 'zustand';

const useStore = create((set, get) => ({
  // Active instance
  activeInstanceId: null,
  setActiveInstance: id => set({ activeInstanceId: id }),

  // Health status
  health: null,
  setHealth: health => set({ health }),

  // Sidebar
  sidebarOpen: true,
  toggleSidebar: () => set(s => ({ sidebarOpen: !s.sidebarOpen })),

  // Current user (set after login, cleared on logout)
  currentUser: null,
  setCurrentUser:   user => set({ currentUser: user }),
  clearCurrentUser: ()   => set({ currentUser: null }),
}));

export default useStore;
